import extend from 'extend';
import convert from 'convert-units';
import freeze from 'deep-freeze-node';
import emissions from '../utils/emissions';

import {
    BASE_TRAVEL_MODE,
    TRANSIT_DISTANCE_COACH,
    PLANE_EMISSIONS_BONUS,
    CONSUMPTION_AMOUNT
} from '@/const';

function updateTransports (travelMode) {
    var transports = travelMode.transports,
        updated = {};

    for (var k in transports) {
        var data = transports[k],
            bonusDistance = 0;

        if (k === 'PLANE') {
            bonusDistance =
                PLANE_EMISSIONS_BONUS.base + (
                    travelMode.distance *
                    PLANE_EMISSIONS_BONUS.coef
                );
        }

        travelMode.distance += bonusDistance;
        data.distance += bonusDistance;

        if (k === 'BUS' && data.distance > TRANSIT_DISTANCE_COACH) {
            updated['COACH'] = data;
        } else {
            updated[k] = data;
        }
    }

    travelMode.transports = updated;
}

function getElectricAlternative (travelMode, journey) {
    var data = extend(true, {}, travelMode);
    data.id = 'electric';

    var modifiedJourney = extend({}, journey, {
        fuel: 'electric',
        consumption: CONSUMPTION_AMOUNT.electric[journey.vehicle]
    });

    data.emissions = emissions.calculate(
        travelMode,
        modifiedJourney
    );

    return data;
}

export default {
    state: {
        result: null,
        customConsumption: null
    },
    getters: {
        journey (state, getters) {
            var result = state.result,
                baseTravelMode = result.travelModes[BASE_TRAVEL_MODE],
                consumption = state.customConsumption;

            var data = {
                vehicle: result.vehicleType,
                fuel: result.fuelType,
                originText: result.route.origin.text,
                destinationText: result.route.destination.text,
                distance: baseTravelMode.distance,
                duration: baseTravelMode.duration
            };

            if (consumption) {
                data.consumption = consumption;
            } else {
                data.consumption = emissions.getConsumption({
                    vehicle: data.vehicle,
                    fuel: data.fuel
                });
            }

            return data;
        },
        travelModes (state, getters) {
            var values = [];

            for (var mode in state.result.travelModes) {
                var data = state.result.travelModes[mode];

                if (data) {
                    var travelMode = extend(true, {}, data);
                    updateTransports(travelMode);

                    extend(travelMode, {
                        id: mode,
                        emissions: emissions.calculate(travelMode, getters.journey)
                    });

                    values.push(travelMode);
                }
            }

            return values;
        },
        baseTravelMode (state, getters) {
            return getters.travelModes.find((element) => {
                return element.id === BASE_TRAVEL_MODE;
            });
        },
        alternatives (state, getters, rootState) {
            var base = getters.baseTravelMode;

            var alternatives = getters.travelModes.filter((element) => {
                return element.id !== base.id;
            });

            if (getters.journey.fuel !== 'electric') {
                alternatives.push(getElectricAlternative(base, getters.journey));
            }

            return alternatives.map((element) => {
                var compared = {};

                for (var k in element.emissions) {
                    compared[k] = element.emissions[k] - base.emissions[k];
                }

                return extend({}, element, {
                    comparedDuration: element.duration - base.duration,
                    comparedDistance: element.distance - base.distance,
                    comparedEmissions: compared
                });
            });
        }
    },
    mutations: {
        setResultData (store, value) {
            store.result = freeze(value);
        },
        setConsumption (store, value) {
            store.customConsumption = value;
        }
    },
    actions: {
        incrementConsumption ({ getters, commit }, data) {
            var baseUnit = getters.journey.fuel === 'electric' ? 'km' : 'l/100km';
            var current = convert(getters.journey.consumption).from(baseUnit).to(data.unit),
                newValue = current + data.delta;

            if (newValue < 1) {
                newValue = 1;
            }

            newValue = convert(newValue).from(data.unit).to(baseUnit);
            commit('setConsumption', newValue);
        }
    }
};
